import { Descriptions, Typography } from 'antd';
import { customDataValues } from './custom_data';

export default function CustomDataPreview({ campaign }) {
    const entries = Object.entries(customDataValues(campaign));
    return entries.length ? <Descriptions size="small" column={1} items={entries.map(([key, value]) => ({
        key, label: key, children: <span style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{value || '（空）'}</span>,
    }))} styles={{ label: { overflowWrap: 'anywhere', maxWidth: 160 } }} /> : <Typography.Text type="secondary">尚未配置参数</Typography.Text>;
}
